import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Table } from 'antd';
import { registryLink } from 'util/NavigationUtils.jsx';
import { stateToIconFormatter,
  academicYearFormatter,
  formaDidatticaFormatter,
  infoFormatter,
  insegnamentoFormatter,
  oreSommateFormatter,
} from 'util/Formatters.jsx';

const Panel = Collapse.Panel;
const columns = [
  {
    title: 'Stato',
    dataIndex: 'stato',
    className: 'text-center',
    key: 'regState',
    render: state => stateToIconFormatter(state),
  },
  {
    title: 'Anno Accademico',
    dataIndex: 'annoAccademico',
    key: 'annoAcc',
    render: year => academicYearFormatter(year)
  },
  {
    title: 'Insegnamento',
    dataIndex: 'descInsegnamento',
    key: 'nomeInsegnamento',
    render: (descIns, row) => insegnamentoFormatter(descIns, row),
  },
  {
    title: 'Forma Didattica',
    dataIndex: 'descFD',
    key: 'formaDid',
    render: descFD => formaDidatticaFormatter(descFD),
  },
  { title: 'Modalità di Copertura', dataIndex: 'descCopertura', key: 'codCopertura' },
  {
    title: 'Altre Informazioni',
    dataIndex: 'codAF',
    key: 'moreInfo',
    render: (codAF, row) => infoFormatter(codAF, row),
  },
  { title: 'Ore Registrate/Assegnate',
    dataIndex: 'totaliAssegnate',
    className: 'text-center',
    key: 'ore',
    render: (totaliAssegnate, row) => oreSommateFormatter(totaliAssegnate, row),
  },
];

class CriticalList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      calledWs: false,
    };
  }

  onRegistryClick = (record) => {
    if (!record.idRegistro) {
      this.props.openingEduRecord(record.idCopertura)
      .then((response) => {
        record.idRegistro = response.payload.idRegistro;
        registryLink(record);
      });
    } else {
      registryLink(record);
    }
  }

  render() {
    if (this.props.registriCritical && this.props.registriCritical.length > 0) {
      return (
        <Collapse className="box box-solid box-unimi-alert collapsed-box vmg10">
          <Panel header="Attenzione: registri incompleti anni precedenti!">
            <Table
              rowKey="idCopertura"
              className="registriTable"
              onRowClick={this.onRegistryClick}
              rowClassName="row-link"
              columns={columns}
              dataSource={this.props.registriCritical}
              pagination={false}
            />
          </Panel>
        </Collapse>
      );
    }
    return (<div></div>);
  }
}

CriticalList.propTypes = {
  registriCritical: PropTypes.arrayOf(PropTypes.object).isRequired,
  openingEduRecord: PropTypes.func,
};

export { CriticalList };
